import { kea } from "kea";
import api from '../utils/api';

import grouplogic from "./group";
import vehiclelogic from "./vehicle";
import profilelogic from "./profile";
import checkRole from "src/utils/checkRole";

export const geofencelogic = kea({
	actions: {
		create: (geofence) => ({ geofence }),
		fetchAll: true,
		update: (geofence) => ({ geofence }),
		remove: (geofence) => ({ geofence }),
		updateGroup: (geofence) => ({ geofence }),

		setAll: (geofences) => ({ geofences }),
		setOne: (geofence) => ({ geofence }),
		addOne: (geofence) => ({ geofence }),
		removeOne: (geofence) => ({ geofence }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),

		onMapAdd: (geofence) => ({ geofence }),
		onMapRemove: (geofence) => ({ geofence }),
	},
	selectors: {
		geofencesOnMap: [
			(selectors) => [selectors.geofences, selectors.onMap],
			(geofences, onMap) => geofences?.filter(geofence => onMap.includes(geofence._id))
		]
	},
	reducers: {
		geofences: [null, {
			setAll: (_, { geofences }) => geofences,
			setOne: (state, { geofence }) => state.map((s) => s._id === geofence._id ? geofence : s),
			addOne: (state, { geofence }) => [...state, geofence],
			removeOne: (state, { geofence }) => state.filter((s) => geofence._id !== s._id),
		}],
		onMap: [[], {
			onMapAdd: (state, { geofence }) => [...state, geofence],
			onMapRemove: (state, { geofence }) => state.filter((_id) => geofence !== _id),
		}],
		loading: [false, {
			create: () => true,
			fetchAll: () => true,
			update: () => true,
			remove: () => true,
			updateGroup: () => true,

			setAll: () => false,
			setOne: () => false,
			addOne: () => false,
			removeOne: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			setAll: () => null,
			setOne: () => null,
			addOne: () => null,
			removeOne: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		create: async ({ geofence }, breakpoint) => {
			await breakpoint(300);
			let url = '/geofence';
			let res;
			try {
				res = await api({ url, method: 'post', body: geofence });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.addOne(json.payload);
				actions.setSuccess('Geofence Created.');
				actions.onMapAdd(json.payload);
			} else actions.setError(json.error);
		},
		fetchAll: async (_, breakpoint) => {
			await breakpoint(300)
			let url = '/geofence';
			let res;
			try {
				res = await api({ url });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			breakpoint();
			const json = await res.json();
			if (res.ok) actions.setAll(json.payload);
			else actions.setError(json.error);
		},
		update: async ({ geofence }, breakpoint) => {
			await breakpoint(300);
			let url = `/geofence/${geofence._id}`;
			let res;
			try {
				res = await api({ url, method: 'put', body: geofence });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Geofence Updated.');
			} else actions.setError(json.error);
		},
		remove: async ({ geofence }, breakpoint) => {
			await breakpoint(300);
			let url = `/geofence/${geofence._id}`;
			let res;
			try {
				res = await api({ url, method: 'delete' });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.removeOne(geofence);
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				if (checkRole(profilelogic.values.profile, ['VehicleView'])) vehiclelogic.actions.fetchAll();
				actions.setSuccess('Geofence Removed.');
			} else actions.setError(json.error);
		},
		updateGroup: async ({ geofence }, breakpoint) => {
			await breakpoint(300);
			let url = `/geofence/${geofence._id}/group`;
			let res;
			try {
				res = await api({ url, method: 'put', body: geofence });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.setOne(json.payload)
				if (checkRole(profilelogic.values.profile, ['Admin'])) grouplogic.actions.fetchAll();
				actions.setSuccess('Geofence Updated.');
			} else actions.setError(json.error);
		}
	})
});

export default geofencelogic;